import React from "react";
import HeaderNavigationMobile from "./HeaderNavigationMobile";
import LanguageSwitcher from "./LanguageSwitcher";
import { DropDirection } from "../types/constants";

interface Props {
    isOpen: boolean;
    onClose: () => void;
}

export default function MobileBar({ isOpen, onClose }: Props) {
    if (!isOpen) return null;

    return (
        <>
            <div className="fixed inset-0 bg-[#0A2C5C]/60 backdrop-blur-[4px] z-40" onClick={onClose} />
            <div
                className={`
                    fixed top-0 right-0 h-screen bg-white z-50 transform transition-transform duration-300
                    w-[280px] md:w-[320px] lap:w-[480px]
                    ${isOpen ? "translate-x-0" : "translate-x-full"}
                `}
                style={{
                    paddingTop: 61,
                    paddingRight: 40,
                    paddingBottom: 61,
                    paddingLeft: 40,
                }}
            >
                <button
                    onClick={onClose}
                    aria-label="Close menu"
                    className="
                        absolute 
                        top-[61px] right-[40px] lap:right-[130px] w-[20px] h-[20px] 
                        md:top-[63px] md:w-[27px] md:h-[27px] 
                        lap:top-[65px] lap:w-[27px] lap:h-[27px]
                    "
                >
                    <div className="w-full h-[2px] bg-[#1750A4] rotate-45 translate-y-[3px] md:translate-y-[3.5px]" />
                    <div className="w-full h-[2px] bg-[#1750A4] -rotate-45" />
                </button>
                <div className="mx-auto flex flex-col mt-[40px] justify-between h-full w-[206px]">
                    <div className="flex flex-col mt-[40px]">
                        <HeaderNavigationMobile />
                    </div>

                    <div className="flex justify-end">
                        <LanguageSwitcher dropDirection={DropDirection.UP} dropdownRightOffset="right-0" />
                    </div>
                </div>
            </div>
        </>
    );
}
